import PropTypes from 'prop-types'

import ScriptLoader from '@s-ui/react-script-loader'

const NO_OP = () => {}

const AppsFlyerSmartScriptLoader = ({onLoad = NO_OP}) => {
  const APPS_FLYER_SMART_SCRIPT_URL = 'https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js'

  return (
    <ScriptLoader
      src={APPS_FLYER_SMART_SCRIPT_URL}
      isAsync
      verifier={() => window && window.AF_SMART_SCRIPT}
      render={() => {
        console.log('AppsFlyer SmartScript loaded')
        return onLoad()
      }}
    />
  )
}
AppsFlyerSmartScriptLoader.displayName = 'AppsFlyerSmartScriptLoader'
AppsFlyerSmartScriptLoader.propTypes = {
  onLoad: PropTypes.func
}
export default AppsFlyerSmartScriptLoader
